import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const ResponsiveCard = ({
  title,
  subheader,
  content,
  actions,
  elevation = 1,
  sx = {},
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      elevation={elevation}
      sx={{
        width: "100%",
        mb: 2,
        ...sx,
      }}
    >
      {(title || subheader) && (
        <Box sx={{ p: isMobile ? 2 : 3, pb: 0 }}>
          {title && (
            <Typography
              variant={isMobile ? "h6" : "h5"}
              component="div"
              sx={{ fontWeight: 500 }}
            >
              {title}
            </Typography>
          )}

          {subheader && (
            <Typography
              variant={isMobile ? "body2" : "body1"}
              color="text.secondary"
              sx={{ mt: 0.5 }}
            >
              {subheader}
            </Typography>
          )}
        </Box>
      )}

      <CardContent sx={{ p: isMobile ? 2 : 3 }}>{content}</CardContent>

      {actions && (
        <CardActions
          sx={{
            justifyContent: "flex-end",
            p: isMobile ? 1.5 : 2,
          }}
        >
          {actions}
        </CardActions>
      )}
    </Card>
  );
};

export default ResponsiveCard;
